module.exports = __webpack_public_path__ + "img/img2.3ad04b8c.png";